import React, { ReactElement, useContext, useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../contexts/authContext';
import ConfigContext from '../contexts/configContext';
import GetPermissions from '../pages/_layout/_asides/adminfilter';
import { isRootDealerUser } from '../helpers/adminAccess';

interface IAdminRouteGuardProps {
	children: ReactElement;
	permissionKey: string;
}

const AdminRouteGuard = ({ children, permissionKey }: IAdminRouteGuardProps) => {
	const { userData, dealerPermissions } = useContext(AuthContext);
	const { publicSettings } = useContext(ConfigContext);

	const isRootUser = useMemo(() => {
		return isRootDealerUser(publicSettings, userData.userName);
	}, [publicSettings, userData.userName]);

	const permissions = useMemo(
		() => GetPermissions(dealerPermissions, Boolean(isRootUser), userData),
		[dealerPermissions, isRootUser, userData],
	);

	if (userData.userTypeId !== 3) {
		return children;
	}

	if (!permissions[permissionKey]) {
		return <Navigate to='/admin' replace />;
	}

	return children;
};

export default AdminRouteGuard;
